import React, {useMemo} from "react";
import "./ProductTabs.css";
import CurriculumFlipbookContent from "../../curriculum/CurriculumFlipbookContent";
import CurriculumOtherContent from "../../curriculum/CurriculumOtherContent";
import Slider from "react-slick";
const Models = (props) => {

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 800,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        cssEase: "ease-in-out",
        pauseOnHover: true,
        pauseOnFocus: true,
    };
    const activeTabData = props?.activeTabData;
    const { curriculumFlipbookContent, curriculumOtherContent } = useMemo(() => {
        const flipbook = {};
        const otherContent = [];
        activeTabData?.content_array?.forEach((res) => {
            if (res.type === 'flipbook') {
                flipbook[res.flipbook_code] = flipbook[res.flipbook_code] || [];
                flipbook[res.flipbook_code].push(res);
            } else {
                otherContent.push(res);
            }
        });

        return {
            curriculumFlipbookContent: flipbook,
            curriculumOtherContent: otherContent
        };
    }, [activeTabData]);
    const curriculumOtherContentHtml = (curriculum) =>{
        return curriculum.map((content, index) => (
             <CurriculumOtherContent key={index} content={content} />
        ))
    }
    return (
        <div className='descriptionbox'>
            <>
                {Object.values(curriculumFlipbookContent).map((flipbook, index) => (
                    <CurriculumFlipbookContent key={index} contentData={flipbook} />
                ))}
                {curriculumOtherContent.length > 1 ?
                <Slider {...settings}>
                    {curriculumOtherContentHtml(curriculumOtherContent)}
                </Slider> : curriculumOtherContentHtml(curriculumOtherContent)}
            </>
        </div>
    )
}

export default Models
